import { IconButton, Tooltip } from '@material-ui/core';
import SyncAltOutlined from '@material-ui/icons/SyncAltOutlined';
import { httpClient } from 'api/httpClient';
import { SyncEntities } from 'entities/SyncEntities';
import React from 'react';
import { useRefresh, useTranslate } from 'react-admin';
import { useNotifyError } from 'utils/notifiers/useNotifyError';
import { useNotifySuccess } from 'utils/notifiers/useNotifySuccess';

export const SyncEntityButton = ({ syncEntityId, title }) => {
    const t = useTranslate();
    const refresh = useRefresh();
    const notifySuccess = useNotifySuccess();
    const notifyError = useNotifyError();

    const handleClick = async () => {
        try {
            await httpClient(`/sync/${syncEntityId}`, {
                method: 'POST',
            });
            notifySuccess(t('osfc.messages.success'));
            refresh()
        } catch {
            notifyError(t('osfc.messages.unsuccess'));
        }
    };

    if (Object.values(SyncEntities).indexOf(syncEntityId) === -1) return;

    return (
        <Tooltip title={t(title)}>
            <IconButton
                aria-label="sync"
                onClick={handleClick}
                color='primary'
            >
                <SyncAltOutlined />
            </IconButton>
        </Tooltip>
    );
};
